import { getApiBaseUrl, getApiClient } from "./serviceconfig";

var apiBaseUrl = getApiBaseUrl();

export async function getAllCompanies(cookies,searchString) {

  let url= `${apiBaseUrl}/entity_company/`;
  if (searchString) {
    url = url + `?name=${searchString}`;
  }
    return getApiClient(cookies).get(url)
      .then(response => response.data);
}

export async function createCompany(cookies, inputs) {

  return getApiClient(cookies).post(`${apiBaseUrl}/entity_company/`, inputs, {
    headers: {
      "Content-Type": "multipart/form-data",
  }});
  
  }

export function updateCompany(cookies, inputs, companyId) {
  
  return getApiClient(cookies)
  .put(`${apiBaseUrl}/entity_company/${companyId}/`, inputs, {
    headers: {
      "Content-Type": "multipart/form-data",
  }})
}

export async function getCompanyDetails(cookies, companyId) {

  return getApiClient(cookies)
  .get(`${apiBaseUrl}/entity_company/${companyId}/`)
  .then(response => response.data);
}

// export async function getPlantDetails(cookies, companyId) {

//   return getApiClient(cookies).get(`${apiBaseUrl}/entity_plant/${companyId}/companies`)
//         .then((response) => response.data);
// }
export function deleteCompany(cookies, companyId) {

  return getApiClient(cookies).delete(`${apiBaseUrl}/entity_company/${companyId}/`); 
}

export async function testEinvoiceConnection(cookies, companyId) {
  return getApiClient(cookies)
    .post(`${apiBaseUrl}/entity_company/${companyId}/test_einvoice_connection/`)
    .then(response => response.data);
}

function buildPlantActivityParams(filters = {}) {
  const params = {};
  if (filters.fromDate) {
    params.from_date = filters.fromDate;
  }
  if (filters.toDate) {
    params.to_date = filters.toDate;
  }
  if (filters.plantId) {
    params.plant_id = filters.plantId;
  }
  return params;
}

export async function getCompanyPlantActivitySummary(cookies, companyId, filters = {}) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/entity_company/${companyId}/plant_activity_summary/`, {
      params: buildPlantActivityParams(filters),
    })
    .then(response => response.data);
}

export async function getCompanyPlantActivityDetails(cookies, companyId, plantId, activityType, filters = {}) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/entity_company/${companyId}/plant_activity_details/`, {
      params: {
        plant_id: plantId,
        type: activityType,
        ...buildPlantActivityParams(filters),
      },
    })
    .then(response => response.data);
}

